// Modules.
import CommonModules, { Plugins } from '@store'

export default {
  strict: __DEBUG__,
  state: {
    isHsia: true
  },
  modules: {
    global: CommonModules.global,
    responsive: CommonModules.responsive,
    variants: CommonModules.variants,
    overlay: CommonModules.overlay,
    auth: CommonModules.auth,
  },
  plugins: [Plugins[0]]
}
